const settlementEligibilityUrl = "v1/credit/account/payment-plans/settlement";
export {
  settlementEligibilityUrl
};
//# sourceMappingURL=endpoints.js.map
